import React, { FC, useCallback } from 'react';

import { ListItemButton, ListItemContent } from './styled';
import { IProductDetailListItemProps } from './types';

export const Container: FC<React.PropsWithChildren<Partial<IProductDetailListItemProps>>> = ({
  children,
  isClickable,
  onProductClick,
  onNavigate,
  accessibilityRole,
  accessibilityLabel,
  accessibilitySelected,
  accessibilityChecked,
}) => {
  const wrappedOnProductCta = useCallback(
    (e: any) => {
      e?.preventDefault();
      if (onNavigate) {
        onNavigate();
      } else if (onProductClick) {
        onProductClick();
      }
    },
    [onProductClick, onNavigate]
  );

  const listItemRole = onNavigate ? 'link' : undefined;

  if (isClickable) {
    return (
      <ListItemButton
        testID="product-list-item-button"
        onPress={wrappedOnProductCta}
        accessible
        focusable
        href="#"
        {...(listItemRole && { accessibilityRole: listItemRole })}
        {...(accessibilityLabel && { accessibilityLabel })}
        {...(accessibilitySelected && { accessibilitySelected })}
        {...(accessibilityChecked && { accessibilityChecked })}
      >
        {children}
      </ListItemButton>
    );
  }
  return <ListItemContent testID="product-list-item-content">{children}</ListItemContent>;
};
